export default {
    init() {
        setupHeader();
        toggleOffCanvasMenu();
    }
}

function setupHeader() {
    let $header = $('#header');

    checkForWpAdminBar($header);
    $(window).smartresize(function(){
        checkForWpAdminBar($header);
    });

    $(window).on('scroll', function() {
        if (($header.outerHeight()) > $(this).scrollTop()) {
            $header.css('background', 'transparent');
        } else {
            $header.css('background', 'linear-gradient(rgba(0,0,77,1) 10%, rgba(0,0,77,0) 100%)');
        }
    });
}

function checkForWpAdminBar($header) {
    let $wpAdminBar = $('#wpadminbar');

    if($wpAdminBar.length) {
        $wpAdminBar.css('position', 'fixed');
        $header.css('top', $wpAdminBar.innerHeight() + 'px');
    }
}

function toggleOffCanvasMenu() {
    let burgerMenu = document.querySelector('.burger-menu');

    burgerMenu.addEventListener('click', function() {
        burgerMenu.classList.toggle('open');
    });

    displayOverlayAndContent();
}

function displayOverlayAndContent() {
    let button = document.querySelector('.triggermenu');
    let overlay = document.getElementById('ocm-overlay-content');
    let burgerMenu = document.querySelector('.burger-menu');

    button.addEventListener('click', function () {
        overlay.classList.toggle('open');

        if (overlay.classList.contains('open')) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
    });

    document.querySelectorAll('.menu-link-item').forEach(menuLinkItem => {
        menuLinkItem.addEventListener('click', function(event) {
            event.preventDefault();

            const href = event.currentTarget.getAttribute('href');

            overlay.classList.remove('open');
            burgerMenu.classList.remove('open');
            document.body.style.overflow = '';

            setTimeout(() => {
                window.location.href = href;
            }, 400);
        });
    });
}
